import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import allowUber from "./allowUber";

const AllowUberRoute = ({ children }) => {
    const [isAllowed, setIsAllowed] = useState(null);
    const { campaign_id, sitecanvass_id, doorcanvass_id } = useSelector(state => ({
        campaign_id: state.session.focusedCampaign?.id,
    }));

    // const fullState = useSelector(state => state);
    // console.log('Redux state:', fullState);

    useEffect(() => {
        const checkAccess = async () => {
            const allowed = await allowUber({ campaign_id, sitecanvass_id, doorcanvass_id });
            setIsAllowed(allowed);
        };
        checkAccess();
    }, [campaign_id, sitecanvass_id, doorcanvass_id]);

    if (isAllowed === null) return <div>Loading...</div>;
    if (!isAllowed) return <Navigate to="/" replace />;

    return children;
};

export default AllowUberRoute;